import { render, staticRenderFns } from "./infoSure.vue?vue&type=template&id=5c5a524e&scoped=true"
import script from "./infoSure.vue?vue&type=script&lang=js"
export * from "./infoSure.vue?vue&type=script&lang=js"
import style0 from "./infoSure.vue?vue&type=style&index=0&id=5c5a524e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a524e",
  null
  
)

export default component.exports